import { render, staticRenderFns } from "./PointReceipt.vue?vue&type=template&id=c4c848ce&scoped=true"
import script from "./PointReceipt.vue?vue&type=script&lang=js"
export * from "./PointReceipt.vue?vue&type=script&lang=js"
import style0 from "./PointReceipt.vue?vue&type=style&index=0&id=c4c848ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c848ce",
  null
  
)

export default component.exports